export const commonResponseAdapterCost = (res) => {
  return res ? res?.response?.[0] : {};
};
